import axios, { endpoints } from "../../libs/axios";

export const fetchProducts = async (payload: string[]) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.set("limit", "999");
    queryParams.set("sortOrder", "asc");

    if (payload?.length) {
      queryParams.set("category", payload.join(","));
    }
    const url = `${endpoints.product.list}?${queryParams.toString()}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchProductsByID = async (id: string) => {
  const url = `${endpoints.product.details}/${id}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch product by ID");
    throw error;
  }
};

export const fetchProductsByTagSlug = async (slug: string) => {
  try {
    const url = `${endpoints.productTag.products}?slug=${encodeURIComponent(slug)}`;
    const response = await axios.get(url);
    const data = response.data;
    return Array.isArray(data?.products) ? data.products : [];
  } catch (error) {
    throw error;
  }
};

export const uploadFle = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("file", payload);
    const response = await axios.post(endpoints?.upload, formData);
    return response.data;
  } catch (error) {
    console.error("Failed to upload file");
    throw error;
  }
};

export const getConfigFle = async (payload: any) => {
  try {
    const response = await axios.get(
      `${endpoints?.product?.config}/${payload}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get config");
    throw error;
  }
};

export const fetchPrice = async (payload: any) => {
  try {
    const response = await axios.post(
      endpoints?.product?.calculatePrice,
      payload
    );
    return response?.data;
  } catch (error) {
    console.error("Failed to get price");
    throw error;
  }
};
